type Props = {
  readonly size?: number;
};
export function ManagedTagIcon({ size = 20 }: Props) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.50001 16.6666C11.1819 16.6666 14.1667 13.6818 14.1667 9.99992C14.1667 6.31802 11.1819 3.33325 7.50001 3.33325C3.81811 3.33325 0.833344 6.31802 0.833344 9.99992C0.833344 13.6818 3.81811 16.6666 7.50001 16.6666Z"
        fill="url(#paint0_radial_712_29210)"
      />
      <path
        d="M14.1667 3.5498V5.29147C16.1084 5.9748 17.5 7.8248 17.5 9.9998C17.5 12.1748 16.1084 14.0248 14.1667 14.7081V16.4498C17.0417 15.7081 19.1667 13.1081 19.1667 9.9998C19.1667 6.89147 17.0417 4.29147 14.1667 3.5498Z"
        fill="url(#paint1_radial_712_29210)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_712_29210"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.8333 7.30151) rotate(129.289) scale(15.7919)"
        >
          <stop stopColor="#1B91D3" />
          <stop offset="1" stopColor="#D3F6D6" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_712_29210"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.9167 7.38909) rotate(107.595) scale(12.4054 7.29355)"
        >
          <stop stopColor="#1B91D3" />
          <stop offset="1" stopColor="#D3F6D6" />
        </radialGradient>
      </defs>
    </svg>
  );
}
